export interface DataSource {
  id: string
  name: string
  source_type: string
  source_identifier: string
  sync_strategy: string
  last_synced_id: string | null
  last_synced_at: string | null
  incremental_sync_date: string | null
  sync_interval: string | null
  target_model: string | null
  processor_class: string | null
  resync_lookback_days: number
  frequent_sync_days: number | null
  org_node_id: string | null
  created_at: string
  source_url: string | null
  target_table: string | null
  target_count: number | null
}

export interface OrgNode {
  id: string
  parent_id: string | null
  name: string
  depth: number
}

export function nodeLabel(node: OrgNode, byId: Record<string, OrgNode>): string {
  const path: string[] = [node.name]
  let cur: OrgNode | undefined = node
  while (cur && cur.parent_id) {
    cur = byId[cur.parent_id]
    if (cur) path.unshift(cur.name)
  }
  return path.join(' › ')
}
